(() => {
  const menuToggle = document.querySelector('.menu-toggle');
  const mobileMenu = document.getElementById('MobileMenu');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const expanded = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!expanded));
      mobileMenu.hidden = expanded;
    });
  }

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const jsonEl = root.querySelector('[data-variant-json]');
    if (!jsonEl) return;
    let variants = [];
    try { variants = JSON.parse(jsonEl.textContent); } catch (_) { return; }
    const selects = [...root.querySelectorAll('[data-option-select]')];
    const idInput = root.querySelector('[data-variant-id]');
    const priceEl = root.querySelector('[data-product-price]');
    const addButton = root.querySelector('[data-add-button]');
    const currency = root.dataset.currency || 'USD';
    const money = (cents) => new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(Number(cents) / 100);

    const updateVariant = () => {
      const selected = selects.map((select) => select.value);
      const variant = variants.find((v) => v.options.every((value, i) => value === selected[i]));
      if (!variant) {
        if (addButton) { addButton.disabled = true; addButton.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
      if (variant.featured_image && variant.featured_image.src) {
        const img = root.querySelector('[data-main-product-image]');
        const frame = img && img.closest('.product-main-image');
        if (img) {
          if (frame) frame.classList.add('is-changing');
          const nextSrc = variant.featured_image.src;
          const preload = new Image();
          preload.onload = () => {
            img.src = nextSrc;
            if (frame) frame.classList.remove('is-changing');
          };
          preload.onerror = () => {
            img.src = nextSrc;
            if (frame) frame.classList.remove('is-changing');
          };
          preload.src = nextSrc;
        }
      }
    };
    selects.forEach((select) => select.addEventListener('change', updateVariant));

    const swatchColor = (name) => {
      const n = String(name || '').toLowerCase();
      if (n.includes('black')) return '#262626';
      if (n.includes('white')) return '#f2eee4';
      if (n.includes('athletic heather')) return '#c9c9c9';
      if (n.includes('heather') && (n.includes('grey') || n.includes('gray'))) return '#9f9f9f';
      if (n.includes('grey') || n.includes('gray')) return '#858585';
      if (n.includes('navy')) return '#26324a';
      if (n.includes('steel')) return '#5c7380';
      if (n.includes('blue')) return '#587c98';
      if (n.includes('maroon') || n.includes('oxblood')) return '#6f3139';
      if (n.includes('red')) return '#a7443f';
      if (n.includes('forest') || n.includes('green')) return '#526550';
      if (n.includes('olive')) return '#666746';
      if (n.includes('brown')) return '#6b4d3b';
      if (n.includes('purple')) return '#6a587a';
      if (n.includes('pink')) return '#c98e99';
      if (n.includes('orange')) return '#c57945';
      if (n.includes('yellow') || n.includes('gold')) return '#d0a63b';
      if (n.includes('natural') || n.includes('cream')) return '#e7dcc4';
      return '#d8d2c8';
    };

    root.querySelectorAll('[data-color-field]').forEach((field) => {
      const select = field.querySelector('[data-option-select]');
      const label = field.querySelector('[data-color-label]');
      const choices = [...field.querySelectorAll('[data-color-choice-value]')];
      choices.forEach((button) => {
        const dot = button.querySelector('[data-color-dot]');
        if (dot) dot.style.background = swatchColor(dot.dataset.colorDot);
        button.addEventListener('click', () => {
          if (!select) return;
          select.value = button.dataset.colorChoiceValue;
          choices.forEach((choice) => {
            const active = choice === button;
            choice.classList.toggle('is-selected', active);
            choice.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          if (label) label.textContent = button.dataset.colorChoiceValue;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

  });
})();
